import { render } from "./Figures.vue?vue&type=template&id=2e1547f2&scoped=true&ts=true"
import script from "./Figures.vue?vue&type=script&lang=ts"
export * from "./Figures.vue?vue&type=script&lang=ts"

import "./Figures.vue?vue&type=style&index=0&id=2e1547f2&lang=scss&scoped=true"

import exportComponent from "/builds/witteveenbos/witteveenbos-light-modules/corporate-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1547f2"]])

export default __exports__